import type { LinkedAccount } from "@store/linkedAccountSlice";
import { AccountActionsMenu } from "../AccountActionsMenu";
import { ReconnectButton } from "../ReconnectButton";

interface LinkedAccountCardActionsProps {
  account: LinkedAccount;
  expired: boolean;
}

export const LinkedAccountCardActions = ({ account, expired }: LinkedAccountCardActionsProps) => {
  if (expired) {
    return <ReconnectButton className="shrink-0 self-center" />;
  }

  return <AccountActionsMenu account={account} className="shrink-0 self-start" />;
};
